var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransferUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    fill: "#7289da",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11h-6.5C7.785 11 7 10.215 7 9.25v-1.5a.75.75 0 011.5 0v1.5c0 .138.112.25.25.25h6.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5c0 .965-.785 1.75-1.75 1.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a.75.75 0 01-.75-.75V1a.75.75 0 011.5 0v6.25A.75.75 0 0112 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3.75a.744.744 0 01-.53-.22L12 1.811l-1.72 1.72A.75.75 0 119.219 2.47l2.25-2.25a.75.75 0 011.061 0l2.25 2.25a.75.75 0 01-.53 1.28zM22.25 21H1.75C.785 21 0 20.215 0 19.25V5.75C0 4.785.785 4 1.75 4h3.5a.75.75 0 110 1.5h-3.5a.25.25 0 00-.25.25v13.5c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25V5.75a.25.25 0 00-.25-.25h-3.5a.75.75 0 010-1.5h3.5c.965 0 1.75.785 1.75 1.75v13.5c0 .965-.785 1.75-1.75 1.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 17.5H.75a.75.75 0 010-1.5h22.5a.75.75 0 010 1.5zM15.25 24h-6.5a.75.75 0 01-.53-1.28c1.041-1.041 1.265-2.553 1.267-2.567a.75.75 0 011.487.195 6.725 6.725 0 01-.744 2.152h3.523a6.88 6.88 0 01-.746-2.147.75.75 0 011.486-.207c.007.045.232 1.469 1.184 2.487A.75.75 0 0115.25 24z"
  })));
}

export default SvgIconTransferUpload;